// source: pbtypes/mobile/phone/location.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_skills_lost_connection_destination_pb = require('../../../pbtypes/gen/skills/lost_connection_destination_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_lost_connection_destination_pb);
var pbtypes_vehicle_ambassador_ambassador_pb = require('../../../pbtypes/vehicle/ambassador/ambassador_pb.js');
goog.object.extend(proto, pbtypes_vehicle_ambassador_ambassador_pb);
goog.exportSymbol('proto.phone.VehicleRecoveryInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.phone.VehicleRecoveryInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.phone.VehicleRecoveryInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.phone.VehicleRecoveryInfo.displayName = 'proto.phone.VehicleRecoveryInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.phone.VehicleRecoveryInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.phone.VehicleRecoveryInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.phone.VehicleRecoveryInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.phone.VehicleRecoveryInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
uclock: jspb.Message.getFieldWithDefault(msg, 1, 0),
lostConnectionDestination: (f = msg.getLostConnectionDestination()) && pbtypes_gen_skills_lost_connection_destination_pb.LostConnectionDestination.toObject(includeInstance, f),
vehicleLocation: (f = msg.getVehicleLocation()) && pbtypes_vehicle_ambassador_ambassador_pb.MinimalGps.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.phone.VehicleRecoveryInfo}
 */
proto.phone.VehicleRecoveryInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.phone.VehicleRecoveryInfo;
  return proto.phone.VehicleRecoveryInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.phone.VehicleRecoveryInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.phone.VehicleRecoveryInfo}
 */
proto.phone.VehicleRecoveryInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUclock(value);
      break;
    case 2:
      var value = new pbtypes_gen_skills_lost_connection_destination_pb.LostConnectionDestination;
      reader.readMessage(value,pbtypes_gen_skills_lost_connection_destination_pb.LostConnectionDestination.deserializeBinaryFromReader);
      msg.setLostConnectionDestination(value);
      break;
    case 3:
      var value = new pbtypes_vehicle_ambassador_ambassador_pb.MinimalGps;
      reader.readMessage(value,pbtypes_vehicle_ambassador_ambassador_pb.MinimalGps.deserializeBinaryFromReader);
      msg.setVehicleLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.phone.VehicleRecoveryInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.phone.VehicleRecoveryInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.phone.VehicleRecoveryInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.phone.VehicleRecoveryInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUclock();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getLostConnectionDestination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_skills_lost_connection_destination_pb.LostConnectionDestination.serializeBinaryToWriter
    );
  }
  f = message.getVehicleLocation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_vehicle_ambassador_ambassador_pb.MinimalGps.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 uclock = 1;
 * @return {number}
 */
proto.phone.VehicleRecoveryInfo.prototype.getUclock = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.phone.VehicleRecoveryInfo} returns this
 */
proto.phone.VehicleRecoveryInfo.prototype.setUclock = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional skills.LostConnectionDestination lost_connection_destination = 2;
 * @return {?proto.skills.LostConnectionDestination}
 */
proto.phone.VehicleRecoveryInfo.prototype.getLostConnectionDestination = function() {
  return /** @type{?proto.skills.LostConnectionDestination} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_lost_connection_destination_pb.LostConnectionDestination, 2));
};


/**
 * @param {?proto.skills.LostConnectionDestination|undefined} value
 * @return {!proto.phone.VehicleRecoveryInfo} returns this
*/
proto.phone.VehicleRecoveryInfo.prototype.setLostConnectionDestination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.phone.VehicleRecoveryInfo} returns this
 */
proto.phone.VehicleRecoveryInfo.prototype.clearLostConnectionDestination = function() {
  return this.setLostConnectionDestination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.phone.VehicleRecoveryInfo.prototype.hasLostConnectionDestination = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ambassador.MinimalGps vehicle_location = 3;
 * @return {?proto.ambassador.MinimalGps}
 */
proto.phone.VehicleRecoveryInfo.prototype.getVehicleLocation = function() {
  return /** @type{?proto.ambassador.MinimalGps} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_ambassador_ambassador_pb.MinimalGps, 3));
};


/**
 * @param {?proto.ambassador.MinimalGps|undefined} value
 * @return {!proto.phone.VehicleRecoveryInfo} returns this
*/
proto.phone.VehicleRecoveryInfo.prototype.setVehicleLocation = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.phone.VehicleRecoveryInfo} returns this
 */
proto.phone.VehicleRecoveryInfo.prototype.clearVehicleLocation = function() {
  return this.setVehicleLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.phone.VehicleRecoveryInfo.prototype.hasVehicleLocation = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.phone);
